import { Training } from "@/app/entities/Training";
import { usePaginationQuery } from "@/app/hooks/usePaginationQuery";
import { useTrainingQueries } from "@/app/hooks/useTrainingQueries";
import { Button } from "@/view/components/ui/button";
import { Dialog } from "@/view/components/ui/dialog";
import { Input } from "@/view/components/ui/input";
import { PlusCircle, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BasicTable } from "../../../components/BasicTable";
import useTrainingTable from "../hooks/useTraningTable";
import { useTrainingFormContext } from "../providers/TraningFormProvider";
import { TrainingForm } from "./training-form/TrainingForm";
import { useDebounce } from "@/app/hooks/useDebounce";
import { useState } from "react";

export const TrainingTable = () => {
  const { setIsCreateTrainingModalOpen, isCreateTrainingModalOpen } =
    useTrainingFormContext();

  const { skip, handleChangeParam } = usePaginationQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(500, searchTerm);
  const { data, isError } = useTrainingQueries(
    skip,
    6,
    debouncedSearchTerm ?? "",
  );
  const navigate = useNavigate();

  const table = useTrainingTable({ data: data?.trainings || [] });

  const getPageIndex = () => {
    if (!data) return 0;
    return Math.floor(data.skip / data.limit) + 1;
  };

  const getPageCount = () => {
    if (!data) return 0;
    return Math.ceil(data.total / data.limit);
  };

  const handleNextPage = () => {
    if (!data) return;
    const newPage = data.skip / data.limit + 1;
    if (getPageCount() === getPageIndex()) return;
    const skipValue = newPage * data.limit;
    handleChangeParam("skip", skipValue.toString());
  };

  const handlePreviousPage = () => {
    if (!data) return;
    const newPage = data.skip / data.limit - 1;
    if (newPage < 0) return;
    const skipValue = newPage * data.limit;
    handleChangeParam("skip", skipValue.toString());
  };

  const handleRowClick = (row: Training) => {
    navigate(`/conteudos/gerenciar/treinamentos/${row?._id}`);
  };

  const handleSearch = (search: string) => {
    setSearchTerm(search);
  };

  if (isError) return <div>Error loading trainings.</div>;

  return (
    <>
      <div className="my-5">
        <div className="mb-5 flex w-full items-center justify-between ">
          <div className="relative flex items-center">
            <Search size={20} className="z-2 absolute left-4 top-3" />
            <Input
              className="ml-1 w-96 rounded-3xl pl-10"
              placeholder="Pesquisar"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
          <Button
            className="rounded-full text-white"
            size="lg"
            onClick={() => setIsCreateTrainingModalOpen(true)}
          >
            <PlusCircle className="mr-2" />
            Novo Treinamento
          </Button>
        </div>

        <BasicTable
          getPageCount={getPageCount}
          getPageIndex={getPageIndex}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
          handleRowClick={handleRowClick}
          table={table}
          type="only header"
        />
      </div>
      <Dialog
        open={isCreateTrainingModalOpen}
        onOpenChange={setIsCreateTrainingModalOpen}
      >
        <TrainingForm />
      </Dialog>
    </>
  );
};
